var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.378,
    height: 21.472,
    viewBox: "0 0 17.378 21.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_akar-copy",
    "data-name": "Icon akar-copy",
    transform: "translate(-5.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10040",
    "data-name": "Trac\\xE9 10040",
    d: "M12,5.047V17.331a2.047,2.047,0,0,0,2.047,2.047h8.189a2.047,2.047,0,0,0,2.047-2.047V8.366A2.047,2.047,0,0,0,23.667,6.9L20.274,3.583A2.047,2.047,0,0,0,18.843,3h-4.8A2.047,2.047,0,0,0,12,5.047Z",
    transform: "translate(-1.906)",
    fill: "none",
    stroke: "#d5b1ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10041",
    "data-name": "Trac\\xE9 10041",
    d: "M18.283,21.76v2.047a2.047,2.047,0,0,1-2.047,2.047H8.047A2.047,2.047,0,0,1,6,23.807V12.547A2.047,2.047,0,0,1,8.047,10.5h2.047",
    transform: "translate(0 -2.382)",
    fill: "none",
    stroke: "#d5b1ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.66dff944e687ae3077cedc90702eb18b.svg";
export { ForwardRef as ReactComponent };